import React from "react";
import { FaShieldAlt, FaGlobe } from "react-icons/fa";
import StatsSection from "../../components/cyber-security/StatSection";
import cyberImage from "../../assets/cyber.png";
import user1 from "../../assets/img/one.png";
import user2 from "../../assets/img/two.png";
import user3 from "../../assets/img/three.png";
import WhyCybersecurity from "../../components/cyber-security/Why-cybersecurity";
import CurriculumSection from "../../components/cyber-security/CurriculumSection";
import LearningModesSection from "../../components/cyber-security/Learning-mode-section";
import WhoCanEnroll from "../../components/cyber-security/Who-can-enroll";
import Testimonials from "../../components/cyber-security/Testimonial";
import CTASection from "../../components/cta/Call-to-action";
import Footer from "../../components/footer/footer.component";
import Hero from "../../components/hero/hero.component";
import { Zoom } from "react-reveal";

const Cybersecurity = () => {
  const features = [
    {
      id: 1,
      title: "Defense",
      description: "Master perimeter control and intrusion detection systems.",
      icon: FaShieldAlt,
    },
    {
      id: 2,
      title: "Analysis",
      description:
        "Identify vulnerabilities before they are exploited by attackers.",
      icon: FaGlobe,
    },
  ];

  const enrollMessage = encodeURIComponent(
    `Hello, I'm interested in your Cybersecurity Training Program at Cephas ICT Hub. 
   
    I'd like to know more about the course, including the duration, training schedule, fees, learning format(online or onsite), and how to register.`,
  );

  const contactMessage = encodeURIComponent(
    "Hello, I'm interested in your Cybersecurity Training Program at Cephas ICT Hub. I'd like to know more about the course.",
  );

  return (
    <div>
      <Hero
        pretitle="Cybersecurity Training Program"
        title={
          <>
            Become a Certified
            <br />
            <span className="text-[#030A49]">Cybersecurity</span>
            <br />
            Professional
          </>
        }
        description={
          "The Digital World Needs Protectors. Will You Be One of Them? Master industry-standard tools and defend global infrastructures."
        }
        price="₦500,000"
        duration="5 Months"
        primaryLink={{
          href: `https://wa.me/2348141335945?text=${enrollMessage}`,
          text: "Enroll Now",
        }}
        secondaryLink={{
          href: `https://wa.me/2348141335945?text=${contactMessage}`,
          text: "Contact Us",
        }}
        users={[user1, user2, user3]}
        imageSrc={cyberImage}
        features={features}
      />
      <StatsSection />
      <CurriculumSection />
      <WhyCybersecurity />
      <LearningModesSection />
      <WhoCanEnroll />
      <Testimonials />
      <Zoom>
        <CTASection
          title="Become a Cybersecurity Professional!"
          description="Develop practical cybersecurity skills to identify vulnerabilities, detect threats, and build secure digital environments."
          buttonText="Enroll Now"
          buttonLink={`https://wa.me/2348141335945?text=${contactMessage}`}
        />
      </Zoom>
      <Footer />
    </div>
  );
};

export default Cybersecurity;
